import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (options: IGenericObject) => {
  const { isSelected, hasDropdown, isDropdownOpen, isVisibleOnMobile } = options;
  return StyleSheet.create({
    linkContainer: {
      position: 'relative',
      display: isVisibleOnMobile ? 'flex' : 'none',
      flexDirection: 'column',
      padding: '15px 10px',
      background: palette.black,
      color: palette.white,
      fontSize: '14px',
      lineHeight: '18px',
      maxWidth: 'auto',
      cursor: 'pointer',
      textAlign: 'center',
      justifyContent: 'center',

      [media.tablet]: {
        display: 'flex',
      },

      [media.desktop]: {
        padding: '15px',
        fontSize: '16px',
        lineHeight: '20px',
      },
    },

    linkHeader: {
      position: 'relative',
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'center',
      width: 'min-content',
      fontWeight: 'bold',

      [children('a')]: {
        color: 'inherit',
        textDecoration: 'none',
        textAlign: 'center',
        height: '100%',
        width: 'min-content',
      },
      ':after': {
        display: hasDropdown && isDropdownOpen ? 'none' : 'block',
        position: 'absolute',
        content: '""',
        width: isSelected ? '100%' : '0%',
        opacity: isSelected ? 1 : 0,
        transition: 'all 0.2s linear',
        height: '4px',
        background: palette.red,
        top: 'calc(100% + 4px)',
      },
      ':hover:after': {
        // Desktop Hover
        width: '100%',
        opacity: 1,
      },
    },

    dropdownArrowIndicator: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '7px',
      pointerEvents: 'none',
      [children('span')]: {
        display: 'flex',
        height: 'fit-content',
        width: 'fit-content',
      },

      [media.desktop]: {
        marginLeft: '12px',
      },
    },

    dropdownContainer: {
      display: 'flex',
      visibility: isDropdownOpen ? 'visible' : 'hidden',
      opacity: isDropdownOpen ? 1 : 0,
      transition: 'opacity 0.3s linear',
      position: 'absolute',
      zIndex: 1,
      background: 'inherit',
      width: 'fit-content',
      minWidth: '100%',
      paddingTop: '7px',
      top: 'calc(100% - 15px)',
      left: '50%',
      transform: 'translateX(-50%)',
      flexDirection: 'column',
    },

    dropdownLink: {
      width: '100%',
      padding: 15,
      color: 'inherit',
      borderTop: `1px solid ${palette.red}`,
      textDecoration: 'none',
      fontSize: '12px',
      lineHeight: '16px',
      [media.desktop]: {
        fontSize: '14px',
        lineHeight: '18px',
      },
      ':hover': {
        color: palette.red,
      },
    },
  });
};
